





































































import {Component, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, Getter} from 'vuex-class';
import {ActionTypes, GetterTypes} from '@/modules/neovehicle/store/types';
import {FamilySegment, tabs, vehicleTypes} from '@/modules/neovehicle/models';
import {ClassificationFamilyFilter} from '@/modules/neovehicle/models/filters';
import Search from '@/modules/neovehicle/components/search.component.vue';
import {GET_COUNTRY_SELECTED} from '@/store/root';
import {CountryEnum} from '@/models/Enums';

@Component({
  components: {
    Search,
  },
})
export default class extends Vue {
  public isLoading = false;
  public classificationFamilyFilter!: ClassificationFamilyFilter;
  public vehicleTypes = vehicleTypes;
  public searchFamily: string = '';
  public headers: any = [];

  public headersMap = [
    {text: 'Código', value: 'idFamily', sortable: true, width: 40},
    {text: 'Tipo de Veículo', value: 'vehicletypes'},
    {text: 'Bandeira', value: 'familybrandname'},
    {text: 'Família', value: 'familyname'},
    {text: '', value: 'idFamily', sortable: false},
  ];

  @Getter(GET_COUNTRY_SELECTED)
  public countrySelected: CountryEnum;

  @Getter(GetterTypes.GET_FAMILIES_SEGMENT)
  public families: FamilySegment[];

  @Action(ActionTypes.FETCH_FAMILIES_EXPORT)
  public fetchFamiliesExport: (country: CountryEnum) => Promise<any>;

  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  public setCurrentTab: (selected: string) => void;

  @Action(ActionTypes.FETCH_FAMILIES_SEGMENT)
  public fetchFamiliesSegment: (filter: ClassificationFamilyFilter) => Promise<FamilySegment[]>;

  @Action(ActionTypes.UPDATE_FAMILY_SEGMENT_SELECTED)
  public setFamilySegmentSelected: (familySegment: FamilySegment | null) => void;

  @Action(ActionTypes.CLEAR_STORE)
  public clearStore: () => void;

  @Watch('countrySelected')
  public changeCountry(selected: CountryEnum) {
    this.classificationFamilyFilter.country = selected;
    this.loadFamilies();
  }

  public get showHeaders() {
    return this.headers.filter(
      (x: any) =>
        typeof x.isClassified === 'undefined' || x.isClassified === this.classificationFamilyFilter.isClassified,
    );
  }

  public onSearch() {
    this.classificationFamilyFilter = {
      ...this.classificationFamilyFilter,
      name: this.searchFamily,
    };
    this.loadFamilies();
  }

  public changeClassified() {
    this.loadFamilies();
  }

  public handleDownload() {
    this.isLoading = true;
    this.fetchFamiliesExport(this.countrySelected)
      .catch((err: any) => console.log(err))
      .finally(() => (this.isLoading = false));
  }

  public handleForm(edit: boolean, familySegment: FamilySegment): void {
    this.setFamilySegmentSelected(familySegment);
    this.$router.push({
      name: 'family_form',
      params: {
        edit: edit.toString(),
      },
    });
    this.setCurrentTab(tabs.form);
  }

  public loadFamilies() {
    this.isLoading = true;
    this.headers = this.headersMap.slice();
    this.fetchFamiliesSegment(this.classificationFamilyFilter).then(
      () => (this.isLoading = false),
    );
  }

  public created() {
    this.clearStore();

    this.classificationFamilyFilter = {
      isClassified: false,
      country: this.countrySelected,
      name: this.searchFamily,
    };

    this.loadFamilies();
  }
}
